// カスタム商品プロパティの管理
class CustomProperties {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener(
      'compositionstart',
      (event) => {
        if (event.target.matches('.cart-item__custom-property')) {
          event.target.dataset.isComposing = 'true';
        }
      },
      true
    );

    document.addEventListener(
      'compositionend',
      (event) => {
        if (event.target.matches('.cart-item__custom-property')) {
          event.target.dataset.isComposing = 'false';
          this.updateCharCount(event.target);
        }
      },
      true
    );

    // 入力中は文字数だけ更新
    document.addEventListener('input', (event) => {
      if (!event.target.matches('.cart-item__custom-property')) return;
      this.updateCharCount(event.target);
    });

    // フォーカス時に元の値を記録
    document.addEventListener(
      'focus',
      (event) => {
        if (!event.target.matches('.cart-item__custom-property')) return;
        event.target.dataset.originalValue = event.target.value || '';
        event.target.dataset.skipNextBlurSave = 'false';
      },
      true
    );

    // change が発火したら保存し、直後の blur では二重保存しない
    document.addEventListener(
      'change',
      (event) => {
        if (!event.target.matches('.cart-item__custom-property')) return;

        const input = event.target;
        const currentValue = input.value || '';
        const originalValue = input.dataset.originalValue || '';

        if (currentValue !== originalValue) {
          input.dataset.skipNextBlurSave = 'true';
          this.saveRow(input);
        }
      },
      true
    );

    // blur時だけ保存
    document.addEventListener(
      'blur',
      (event) => {
        if (!event.target.matches('.cart-item__custom-property')) return;

        const input = event.target;
        const isComposing = input.dataset.isComposing === 'true';
        if (isComposing) return;

        if (input.dataset.skipNextBlurSave === 'true') {
          input.dataset.skipNextBlurSave = 'false';
          return;
        }

        const currentValue = input.value || '';
        const originalValue = input.dataset.originalValue || '';

        if (currentValue !== originalValue) {
          this.saveRow(input);
        }
      },
      true
    );

    // Enterでフォーム送信されるのを防ぐ
    document.addEventListener('keydown', (event) => {
      if (!event.target.matches('.cart-item__custom-property')) return;

      const isComposing =
        event.isComposing ||
        event.target.dataset.isComposing === 'true' ||
        event.keyCode === 229;

      if (event.key === 'Enter' && !isComposing) {
        event.preventDefault();
        event.target.blur();
      }
    });

    this.initCharCounts();
    this.recordInitialValues();
  }

  recordInitialValues() {
    const inputs = document.querySelectorAll('.cart-item__custom-property');
    inputs.forEach((input) => {
      input.dataset.originalValue = input.value || '';
      input.dataset.isComposing = 'false';
      input.dataset.skipNextBlurSave = 'false';
    });
  }

  initCharCounts() {
    const inputs = document.querySelectorAll('.cart-item__custom-property[maxlength]');
    inputs.forEach((input) => this.updateCharCount(input));
  }

  updateCharCount(input) {
    const charCountElement = input.parentElement.querySelector('.char-count .current');
    if (!charCountElement) return;

    const currentLength = input.value.length;
    const maxLength = parseInt(input.getAttribute('maxlength'), 10);
    const charCountContainer = input.parentElement.querySelector('.char-count');

    charCountElement.textContent = currentLength;

    if (!Number.isNaN(maxLength) && currentLength > maxLength) {
      charCountContainer.classList.add('over-limit');
    } else {
      charCountContainer.classList.remove('over-limit');
    }
  }

  getCustomRow(input) {
    return input.closest('.cart-item__custom-row');
  }

  getMainRow(input) {
    const customRow = this.getCustomRow(input);
    if (!customRow) return null;

    let previous = customRow.previousElementSibling;
    while (previous) {
      if (previous.classList && previous.classList.contains('cart-item')) {
        return previous;
      }
      previous = previous.previousElementSibling;
    }
    return null;
  }

  getInputsInSameRow(input) {
    const customRow = this.getCustomRow(input);
    if (!customRow) return [];
    return Array.from(customRow.querySelectorAll('.cart-item__custom-property'));
  }

  getLineNumber(input) {
    const mainRow = this.getMainRow(input);
    if (!mainRow) return null;

    const quantityInput = mainRow.querySelector('.quantity__input[data-index]');
    if (quantityInput && quantityInput.dataset.index) {
      return parseInt(quantityInput.dataset.index, 10);
    }

    const match = (mainRow.id || '').match(/CartItem-(\d+)/);
    if (match) {
      return parseInt(match[1], 10);
    }

    return null;
  }

  getQuantity(input) {
    const mainRow = this.getMainRow(input);
    if (!mainRow) return 1;

    const quantityInput = mainRow.querySelector('.quantity__input');
    if (!quantityInput) return 1;

    const quantity = parseInt(quantityInput.value, 10);
    return Number.isNaN(quantity) ? 1 : quantity;
  }

  buildProperties(input) {
    const properties = {};
    const inputs = this.getInputsInSameRow(input);

    inputs.forEach((field) => {
      const name = field.dataset.propertyName;
      const value = (field.value || '').trim();

      if (value !== '') {
        properties[name] = value;
      }
    });

    return properties;
  }

  saveRow(input) {
    const line = this.getLineNumber(input);
    if (!line) {
      this.showError('更新対象の商品行を取得できませんでした。');
      return;
    }

    const quantity = this.getQuantity(input);
    const properties = this.buildProperties(input);

    this.showLoading(input, true);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        properties: properties,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        return response.json();
      })
      .then(() => {
        const inputs = this.getInputsInSameRow(input);
        inputs.forEach((field) => {
          field.dataset.originalValue = field.value || '';
          field.dataset.skipNextBlurSave = 'false';
        });

        this.updateLivePreview(input);
      })
      .catch((error) => {
        console.error(error);
        this.showError('更新に失敗しました。もう一度お試しください。');
      })
      .finally(() => {
        this.showLoading(input, false);
      });
  }

  updateLivePreview(input) {
    const mainRow = this.getMainRow(input);
    if (!mainRow) return;

    const preview = mainRow.querySelector('[data-live-preview]');
    if (!preview) return;

    const inputs = this.getInputsInSameRow(input);
    let hasVisibleItem = false;

    inputs.forEach((field) => {
      const propertyName = field.dataset.propertyName;
      const value = (field.value || '').trim();
      const target = preview.querySelector(
        `[data-live-property="${propertyName}"]`
      );

      if (!target) return;

      const dd = target.querySelector('dd');
      if (dd) {
        dd.textContent = value;
      }

      if (value !== '') {
        target.hidden = false;
        hasVisibleItem = true;
      } else {
        target.hidden = true;
      }
    });

    preview.hidden = !hasVisibleItem;
  }

  showLoading(input, show) {
    const inputs = this.getInputsInSameRow(input);

    inputs.forEach((field) => {
      if (show) {
        field.disabled = true;
        field.style.opacity = '0.6';
      } else {
        field.disabled = false;
        field.style.opacity = '1';
      }
    });
  }

  showError(message) {
    const oldError = document.querySelector('.ap-custom-properties-error');
    if (oldError) oldError.remove();

    const errorDiv = document.createElement('div');
    errorDiv.className = 'ap-custom-properties-error';
    errorDiv.textContent = message;
    errorDiv.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #ff4444;
      color: white;
      padding: 10px 15px;
      border-radius: 4px;
      z-index: 9999;
      box-shadow: 0 2px 10px rgba(0,0,0,0.3);
    `;

    document.body.appendChild(errorDiv);

    setTimeout(() => {
      if (errorDiv.parentNode) {
        errorDiv.parentNode.removeChild(errorDiv);
      }
    }, 3000);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CustomProperties();
});
